module.exports = __webpack_public_path__ + "img/bg-cursos-tecnico.ed9a1572.png";